import Nav from './Nav';
import Footer from './Footer';

function FAQ() {
  return (
    <div className="App">
      <Nav />

      <main className="main-content">
        <section className="content-section">
          <div className="section-container">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-item">
              <h3>What is Nibblet?</h3>
              <p>Nibblet is an app that helps you save recipes across the internet and makes it easier to follow them step-by-step. Thats it!</p>
            </div>
            <div className="faq-item">
              <h3>How does Nibblet work?</h3>
              <p>Simply share recipes from your favorite apps and websites to Nibblet. You can also create recipes from scratch and edit any imported recipes.</p>
            </div>
            <div className="faq-item">
              <h3>Is Nibblet free to use?</h3>
              <p>Nibblet offers both free and premium plans. The free plan includes 10 imports per month, while premium unlocks 250 imports per month. Manual recipe creation is unlimited for both plans.</p>
            </div>
            <div className="faq-item">
              <h3>Which platforms does Nibblet support?</h3>
              <p>Nibblet is available on iOS and Android.</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default FAQ;